import axios from "axios";
import { setAccessToken, setCsrfToken, setRefreshToken } from "../tokenStore";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Fetch Firebase configuration from the backend
 */
export const getFirebaseConfig = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/web-auth/firebase/config`);
        return response.data;
    } catch (error) {
        const message = error.response?.data?.message || "Failed to load Firebase configuration";
        throw new Error(message);
    }
};

/**
 * Verify Firebase ID Token with backend for Social Login (Google, Facebook, Apple)
 */
export const firebaseSocialLogin = async (idToken, deviceInfo = {}) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/web-auth/firebase/login`,
            {
                idToken,
                device_info: {
                    platform: 'web',
                    device_name: navigator.userAgent,
                    ...deviceInfo
                }
            },
            { withCredentials: true }
        );

        const result = response.data;

        if (result?.success && result?.data?.accessToken) {
            setAccessToken(result.data.accessToken);
            setCsrfToken(result.data.csrfToken || "");
            setRefreshToken(result.data.refreshToken);
        }

        return result;
    } catch (error) {
        const message = error.response?.data?.message || error.message || "Firebase social login failed";
        throw new Error(message);
    }
};

/**
 * Verify Firebase ID Token with backend for Phone Auth (Mobile OTP)
 */
export const firebasePhoneLogin = async (idToken, deviceInfo = {}) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/web-auth/firebase/phone-login`,
            {
                idToken,
                device_info: {
                    platform: 'web',
                    device_name: navigator.userAgent,
                    ...deviceInfo
                }
            },
            { withCredentials: true }
        );

        const result = response.data;

        if (result?.success && result?.data?.accessToken) {
            setAccessToken(result.data.accessToken);
            setCsrfToken(result.data.csrfToken || "");
            setRefreshToken(result.data.refreshToken);
        }

        return result;
    } catch (error) {
        const message = error.response?.data?.message || error.message || "Firebase phone login failed";
        throw new Error(message);
    }
};

/**
 * Fetch Country Flags and Dial Codes from backend
 */
export const getCountryFlags = async (limit = 500) => {
    try {
        const response = await axios.get(`${BASE_URL}/country-flags/?limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error("Fetch Country Flags Error:", error.response?.data || error.message);
        return { success: false, data: { country_flags: [], default_country: null } };
    }
};
